/* Printshop theme — storefront scripts */
var S = function (k, d) { return (window.themeStrings && window.themeStrings[k]) || d; };
document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Global money formatter (used by predictive search + wishlist) ---------- */
  /* Uses a price rendered by Liquid's money filter in the shopper's current currency
     (data-money-sample = 1,234,567.89 formatted), so JS prices match the selected currency. */
  var siteMoneyFormat = document.body.getAttribute('data-money-format') || '${{amount}}';
  var moneySample = document.body.getAttribute('data-money-sample') || '';
  var moneyParts = (function () {
    var m = moneySample.match(/1([^\d]?)234\1(567|568)(?:([^\d])(\d{2}))?/);
    if (!m) return null;
    return { pre: moneySample.slice(0, m.index), post: moneySample.slice(m.index + m[0].length), thou: m[1], dec: m[4] ? m[3] : '', decimals: m[4] ? 2 : 0 };
  })();
  function formatMoney(cents) {
    cents = Number(cents) || 0;
    if (moneyParts) {
      var fixed = (cents / 100).toFixed(moneyParts.decimals).split('.');
      var whole = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, moneyParts.thou);
      return moneyParts.pre + whole + (fixed[1] ? moneyParts.dec + fixed[1] : '') + moneyParts.post;
    }
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    var withThousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return siteMoneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, withThousands + '.' + parts[1]);
  }
  window.BlackoutMoney = formatMoney; window.ThemeMoney = formatMoney;

  /* ---------- AJAX cart: add, count, toast ---------- */
  var body = document.body;
  var cartAddUrl = (body.getAttribute('data-cart-add-url') || '/cart/add') + '.js';
  var cartUrl = body.getAttribute('data-cart-url') || '/cart';

  function addToCart(payload) {
    return fetch(cartAddUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) { throw new Error(data && (data.description || data.message) || S('cart_error','Could not add to cart')); }
        refreshCartCount();
        return data;
      });
    });
  }

  function refreshCartCount() {
    return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        document.querySelectorAll('[data-cart-count-inline]').forEach(function (el) { el.textContent = cart.item_count; });
        return cart;
      }).catch(function () {});
  }

  var toastTimer;
  function showCartToast(item, count, errorText) {
    var toast = document.querySelector('[data-cart-toast]');
    if (!toast) { if (!errorText) window.location.href = cartUrl; return; }
    var title = toast.querySelector('[data-cart-toast-title]');
    var holder = toast.querySelector('[data-cart-toast-item]');
    toast.classList.toggle('is-error', !!errorText);
    if (errorText) {
      title.textContent = S('cart_error','Could not add to cart');
      holder.textContent = errorText;
    } else {
      title.textContent = count > 1 ? S('added_many','[count] products added to cart').replace('[count]', count) : S('added','Added to cart');
      var img = item.featured_image && item.featured_image.url ? item.featured_image.url : (item.image || '');
      holder.innerHTML = (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="">' : '') +
        '<span><strong></strong><small></small></span><b>' + formatMoney(item.final_line_price || item.price) + '</b>';
      holder.querySelector('strong').textContent = item.product_title || item.title || '';
      holder.querySelector('small').textContent = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : (item.vendor || '');
    }
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 5000);
  }
  function hideToast() {
    var toast = document.querySelector('[data-cart-toast]');
    if (!toast) return;
    toast.classList.remove('is-visible');
    setTimeout(function () { toast.hidden = true; }, 250);
  }
  document.addEventListener('click', function (e) { if (e.target.closest('[data-cart-toast-close]')) hideToast(); });
  window.ThemeCart = { add: addToCart, toast: showCartToast, url: cartUrl };

  if (body.getAttribute('data-ajax-cart') === 'true') {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
      var data = new FormData(form);
      var payload = { items: [{ id: parseInt(data.get('id'), 10), quantity: parseInt(data.get('quantity') || '1', 10) || 1 }] };
      addToCart(payload).then(function (res) {
        showCartToast(res.items ? res.items[0] : res, 1);
      }).catch(function (err) {
        showCartToast(null, 0, err.message);
      }).then(function () {
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
      });
    });
  }

  /* ---------- Footer "Cookie settings" link ---------- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-cookie-open]')) return;
    var prefs = document.querySelector('[data-cookie-prefs]');
    if (prefs) prefs.hidden = false;
  });

  /* ---------- Hero slideshow ---------- */
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('.hero__slide');
    var dots = hero.querySelectorAll('.hero__dots button');
    if (slides.length < 2) return;
    var index = 0;
    var timer;

    function show(i) {
      slides.forEach(function (s, si) { s.classList.toggle('is-active', si === i); });
      dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
      index = i;
    }
    function next() { show((index + 1) % slides.length); }
    function prev() { show((index - 1 + slides.length) % slides.length); }
    function restart() { clearInterval(timer); timer = setInterval(next, 5500); }

    hero.querySelector('.hero__arrow--next').addEventListener('click', function () { next(); restart(); });
    hero.querySelector('.hero__arrow--prev').addEventListener('click', function () { prev(); restart(); });
    dots.forEach(function (d, di) { d.addEventListener('click', function () { show(di); restart(); }); });

    restart();
  });

  /* ---------- Horizontal rails (products, tiles, brands, banners) ---------- */
  var RAIL_TRACKS = '.product-rail, .review-rail, .badge-rail, .banner-rail, .category-rail, .cat-tiles, .brand-rail';
  document.querySelectorAll('[data-rail]').forEach(function (wrap) {
    var prev = wrap.querySelector('.rail__arrow--prev');
    var next = wrap.querySelector('.rail__arrow--next');
    if (!prev || !next) return;
    function track() {
      var all = wrap.querySelectorAll(RAIL_TRACKS);
      for (var i = 0; i < all.length; i++) { if (!all[i].hidden && all[i].offsetParent !== null) return all[i]; }
      return all[0];
    }
    function scrollBy(dir) {
      var t = track(); if (!t) return;
      var item = t.firstElementChild;
      var amount = item ? item.getBoundingClientRect().width + 16 : 260;
      t.scrollBy({ left: dir * amount * 2, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { scrollBy(-1); });
    next.addEventListener('click', function () { scrollBy(1); });
  });

  /* ---------- Countdown timers ----------
     data-hours="48"            -> counts 48 h from page load
     data-date="2026-12-25"     -> counts to that date (shopper's local time)
     data-date="12-25"          -> same date every year (rolls over to next year)
     data-start="11-27 00:00"   -> sale event: before the start it counts to the start (.is-upcoming),
                                   then to data-date (.is-live), afterwards .is-done */
  function parseDate(raw, year) {
    var m = (raw || '').trim().match(/^(?:(\d{4})-)?(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
    if (!m) return null;
    return { fixed: !!m[1], t: new Date(m[1] ? parseInt(m[1], 10) : year, parseInt(m[2], 10) - 1, parseInt(m[3], 10), m[4] ? parseInt(m[4], 10) : 0, m[5] ? parseInt(m[5], 10) : 0).getTime() };
  }
  function countdownPlan(el) {
    var now = Date.now(), y = new Date().getFullYear();
    var endRaw = el.getAttribute('data-date'), startRaw = el.getAttribute('data-start');
    var end = parseDate(endRaw, y);
    if (!end) return { start: null, end: now + (parseInt(el.getAttribute('data-hours') || '48', 10) * 3600 * 1000) };
    var start = parseDate(startRaw, y);
    if (start && start.t > end.t && !start.fixed) start = parseDate(startRaw, y - 1);
    if (!end.fixed && end.t < now) {
      end = parseDate(endRaw, y + 1);
      if (start && !start.fixed) start = parseDate(startRaw, y + 1);
      if (start && start.t > end.t) start = parseDate(startRaw, y);
    }
    return { start: start ? start.t : null, end: end.t };
  }
  window.BlackoutCountdownPlan = countdownPlan;
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var plan = countdownPlan(el);
    var host = el.closest('[data-countdown-host]') || el;
    var d = el.querySelector('[data-cd-d]');
    var h = el.querySelector('[data-cd-h]');
    var m = el.querySelector('[data-cd-m]');
    var s = el.querySelector('[data-cd-s]');
    var timer;
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var now = Date.now(), target = plan.end, phase = 'live';
      if (plan.start && now < plan.start) { target = plan.start; phase = 'upcoming'; }
      var diff = Math.max(0, target - now);
      if (diff === 0 && phase === 'live') phase = 'done';
      host.classList.toggle('is-upcoming', phase === 'upcoming');
      host.classList.toggle('is-live', phase === 'live');
      host.classList.toggle('is-done', phase === 'done');
      el.classList.toggle('is-done', phase === 'done');
      if (phase === 'done' && host.hasAttribute('data-hide-when-done')) host.hidden = true;
      var dd = Math.floor(diff / 86400000);
      var hh = d ? Math.floor((diff % 86400000) / 3600000) : Math.floor(diff / 3600000);
      var mm = Math.floor((diff % 3600000) / 60000);
      var ss = Math.floor((diff % 60000) / 1000);
      if (d) d.textContent = pad(dd);
      if (h) h.textContent = pad(hh);
      if (m) m.textContent = pad(mm);
      if (s) s.textContent = pad(ss);
      if (phase === 'done' && timer) clearInterval(timer);
    }
    tick();
    timer = setInterval(tick, 1000);
  });

  /* ---------- Banner effects ([data-fx="snow" | "embers" | "sparks" | "confetti"]) ---------- */
  (function () {
    var hosts = document.querySelectorAll('[data-fx]');
    if (!hosts.length || !window.requestAnimationFrame) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var CONF = ['#FFD200', '#E8202A', '#FFFFFF', '#FFD200', '#FF8A00'];
    hosts.forEach(function (host) {
      var mode = host.getAttribute('data-fx');
      if (['snow', 'embers', 'sparks', 'confetti'].indexOf(mode) < 0) return;
      var rising = mode === 'embers' || mode === 'sparks';
      var c = document.createElement('canvas');
      c.className = 'fx-canvas';
      c.setAttribute('aria-hidden', 'true');
      host.appendChild(c);
      var ctx = c.getContext('2d'), parts = [], w = 0, h = 0, dpr = Math.min(window.devicePixelRatio || 1, 2), running = false, raf;
      function make(randomY) {
        if (rising) return { x: Math.random() * w, y: randomY ? Math.random() * h : h + 6, r: .7 + Math.random() * 1.9, s: .25 + Math.random() * .6, d: Math.random() * 6.28, o: .4 + Math.random() * .5, f: Math.random() * 6.28 };
        if (mode === 'confetti') return { x: Math.random() * w, y: randomY ? Math.random() * h : -10, r: 3 + Math.random() * 4, s: .5 + Math.random() * 1.1, d: Math.random() * 6.28, o: .55 + Math.random() * .4, f: Math.random() * 6.28, c: CONF[Math.floor(Math.random() * CONF.length)] };
        return { x: Math.random() * w, y: randomY ? Math.random() * h : -4, r: .8 + Math.random() * 2.4, s: .25 + Math.random() * .7, d: Math.random() * 6.28, o: .35 + Math.random() * .5, f: 0 };
      }
      function size() {
        w = host.clientWidth; h = host.clientHeight;
        c.width = w * dpr; c.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var cap = rising ? 70 : (mode === 'confetti' ? 60 : 110), per = rising ? 14000 : (mode === 'confetti' ? 16000 : 9000);
        var n = Math.round(Math.min(cap, w * h / per));
        parts = [];
        for (var i = 0; i < n; i++) parts.push(make(true));
      }
      function frame() {
        ctx.clearRect(0, 0, w, h);
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i];
          p.d += .012;
          if (rising) {
            p.y -= p.s; p.x += Math.sin(p.d) * .45; p.f += .08;
            if (p.y < -6) parts[i] = p = make(false);
            ctx.globalAlpha = p.o * (.65 + .35 * Math.sin(p.f)) * Math.min(1, p.y / (h * .5));
            ctx.shadowColor = mode === 'sparks' ? 'rgba(255,210,0,.9)' : 'rgba(255,140,40,.9)'; ctx.shadowBlur = 8;
            ctx.fillStyle = mode === 'sparks' ? '#FFE16A' : '#FFB45A';
            ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill();
          } else if (mode === 'confetti') {
            p.y += p.s; p.x += Math.sin(p.d * 2) * .6; p.f += .05;
            if (p.y > h + 10) parts[i] = p = make(false);
            ctx.globalAlpha = p.o; ctx.shadowBlur = 0; ctx.fillStyle = p.c;
            ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.f);
            ctx.fillRect(-p.r, -p.r * .35 * Math.abs(Math.cos(p.f * 1.7)) - .5, p.r * 2, p.r * .7 * Math.abs(Math.cos(p.f * 1.7)) + 1);
            ctx.restore();
          } else {
            p.y += p.s; p.x += Math.sin(p.d) * .35;
            if (p.y > h + 4) { p.y = -4; p.x = Math.random() * w; }
            ctx.globalAlpha = p.o; ctx.shadowBlur = 0; ctx.fillStyle = '#fff';
            ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283); ctx.fill();
          }
        }
        if (running) raf = requestAnimationFrame(frame);
      }
      function start() { if (!running) { running = true; raf = requestAnimationFrame(frame); } }
      function stop() { running = false; cancelAnimationFrame(raf); }
      size();
      window.addEventListener('resize', size);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { e[0].isIntersecting ? start() : stop(); }).observe(host);
      } else { start(); }
    });
  })();

  /* ---------- Copy coupon codes ([data-copy-code]) ---------- */
  document.querySelectorAll('[data-copy-code]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var code = btn.getAttribute('data-copy-code');
      var label = btn.querySelector('[data-copy-label]');
      var done = function () {
        btn.classList.add('is-copied');
        if (label) { label.setAttribute('data-orig', label.getAttribute('data-orig') || label.textContent); label.textContent = btn.getAttribute('data-copied-text') || S('copied','Copied!'); }
        setTimeout(function () { btn.classList.remove('is-copied'); if (label) label.textContent = label.getAttribute('data-orig'); }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () { fallback(); });
      } else { fallback(); }
      function fallback() {
        var t = document.createElement('textarea'); t.value = code; t.style.position = 'fixed'; t.style.opacity = '0';
        document.body.appendChild(t); t.select();
        try { document.execCommand('copy'); } catch (e) {}
        document.body.removeChild(t); done();
      }
    });
  });

  /* ---------- Quantity selectors ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    if (!input || !wrap.querySelector('[data-qty-minus]')) return;
    wrap.querySelector('[data-qty-minus]').addEventListener('click', function () {
      input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.dispatchEvent(new Event('change'));
    });
    wrap.querySelector('[data-qty-plus]').addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* ---------- Predictive (AJAX) search ---------- */
  document.querySelectorAll('[data-predictive-search]').forEach(function (wrap) {
    var input = wrap.querySelector('[data-search-input]');
    var results = wrap.querySelector('[data-search-results]');
    if (!input || !results) return;

    var debounceTimer;
    var currentTerm = '';
    var abortController;

    function renderResults(term, products) {
      if (!products || products.length === 0) {
        results.innerHTML = '<div class="search-results__empty">' + S('no_results','No results found') + '</div>';
        results.hidden = false;
        return;
      }

      var html = products.map(function (p) {
        var priceNow = formatMoney(p.price);
        var hasCompare = p.compare_at_price_max && p.compare_at_price_max > p.price;
        var priceWas = hasCompare ? formatMoney(p.compare_at_price_max) : '';
        var img = p.image || '';
        return '' +
          '<a href="' + p.url + '" class="search-result">' +
            (img ? '<img src="' + img + '" loading="lazy" alt="' + escapeHtml(p.title) + '">' : '') +
            '<div>' +
              '<div class="search-result__title">' + escapeHtml(p.title) + '</div>' +
              '<div class="search-result__price">' +
                '<span class="now">' + priceNow + '</span>' +
                (hasCompare ? '<span class="was">' + priceWas + '</span>' : '') +
              '</div>' +
            '</div>' +
          '</a>';
      }).join('');

      html += '<a href="/search?q=' + encodeURIComponent(term) + '" class="search-results__viewall">' + S('view_all_results','View all results') + ' &rsaquo;</a>';

      results.innerHTML = html;
      results.hidden = false;
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    }

    function search(term) {
      if (abortController) abortController.abort();
      abortController = new AbortController();

      fetch('/search?q=' + encodeURIComponent(term) + '&type=product&view=ajax', {
        signal: abortController.signal
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = (data && data.products) || [];
          renderResults(term, products);
        })
        .catch(function (err) {
          if (err.name !== 'AbortError') results.hidden = true;
        });
    }

    input.addEventListener('input', function () {
      var term = input.value.trim();
      currentTerm = term;
      clearTimeout(debounceTimer);

      if (term.length < 2) {
        results.hidden = true;
        results.innerHTML = '';
        return;
      }

      debounceTimer = setTimeout(function () {
        search(term);
      }, 250);
    });

    input.addEventListener('focus', function () {
      if (results.innerHTML && input.value.trim().length >= 2) results.hidden = false;
    });

    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) results.hidden = true;
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { results.hidden = true; input.blur(); }
    });
  });

  /* ---------- Mobile menu toggle ---------- */
  var menuBtn = document.querySelector('[data-menu-toggle]');
  var catNav = document.querySelector('[data-cat-nav]');
  if (menuBtn && catNav) {
    menuBtn.addEventListener('click', function () {
      catNav.classList.toggle('is-open');
    });
  }

  /* ---------- Navigation dropdowns (Shop by style, Brands) ---------- */
  (function () {
    var items = document.querySelectorAll('[data-dropdown]');
    if (!items.length) return;
    function closeFlyout() {
      var fl = document.querySelector('[data-categories-flyout]');
      if (fl && !fl.hidden) {
        fl.hidden = true;
        document.querySelectorAll('[data-categories-toggle]').forEach(function (t) { t.classList.remove('is-open'); });
      }
    }
    function closeAll(except) {
      items.forEach(function (it) {
        if (it === except) return;
        it.classList.remove('is-open');
        var b = it.querySelector('[data-dropdown-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
    items.forEach(function (it) {
      var btn = it.querySelector('[data-dropdown-toggle]');
      if (!btn) return;
      it.addEventListener('mouseenter', closeFlyout);
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeFlyout();
        var open = !it.classList.contains('is-open');
        closeAll(it);
        it.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-dropdown]')) closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  })();

  /* ---------- Language & currency selector: country search ---------- */
  document.querySelectorAll('[data-loc]').forEach(function (loc) {
    var input = loc.querySelector('[data-loc-search]');
    var none = loc.querySelector('[data-loc-none]');
    var toggle = loc.querySelector('[data-dropdown-toggle]');
    if (input) {
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var shown = 0;
        loc.querySelectorAll('[data-loc-item]').forEach(function (li) {
          var hit = !q || li.getAttribute('data-loc-item').indexOf(q) !== -1;
          li.hidden = !hit;
          if (hit) shown++;
        });
        if (none) none.hidden = shown !== 0;
      });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    }
    if (toggle) {
      toggle.addEventListener('click', function () {
        setTimeout(function () {
          if (!loc.classList.contains('is-open')) return;
          var active = loc.querySelector('.loc__list--countries .is-active');
          if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest' });
          if (input && window.matchMedia('(min-width: 990px)').matches) input.focus();
        }, 30);
      });
    }
  });

  /* ---------- Categories mega-menu flyout ---------- */
  (function () {
    var toggles = document.querySelectorAll('[data-categories-toggle]');
    var flyout = document.querySelector('[data-categories-flyout]');
    if (toggles.length === 0 || !flyout) return;

    var sidebarBtns = flyout.querySelectorAll('[data-cat-index]');
    var panels = flyout.querySelectorAll('[data-cat-panel]');

    function showPanel(i) {
      sidebarBtns.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-cat-index') === String(i)); });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-cat-panel') === String(i)); });
    }

    function open() {
      document.querySelectorAll('[data-dropdown].is-open').forEach(function (d) { d.classList.remove('is-open'); });
      flyout.hidden = false;
      toggles.forEach(function (t) { t.classList.add('is-open'); });
    }
    function close() {
      flyout.hidden = true;
      toggles.forEach(function (t) { t.classList.remove('is-open'); });
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        if (flyout.hidden) open(); else close();
      });
    });

    sidebarBtns.forEach(function (btn) {
      btn.addEventListener('mouseenter', function () { showPanel(btn.getAttribute('data-cat-index')); });
      /* hover previews the products; click opens the collection (links are real <a> tags) */
      btn.addEventListener('focus', function () { showPanel(btn.getAttribute('data-cat-index')); });
    });

    document.addEventListener('click', function (e) {
      var clickedToggle = false;
      toggles.forEach(function (t) { if (t.contains(e.target)) clickedToggle = true; });
      if (!flyout.hidden && !flyout.contains(e.target) && !clickedToggle) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !flyout.hidden) close();
    });
  })();

  /* ---------- Header: compact on scroll (mobile) ---------- */
  (function () {
    var lastState = false;
    function checkHeaderCompact() {
      var compact = window.scrollY > 40;
      if (compact !== lastState) {
        document.body.classList.toggle('header-compact', compact);
        lastState = compact;
      }
    }
    checkHeaderCompact();
    window.addEventListener('scroll', checkHeaderCompact, { passive: true });
  })();
  /* ---------- AI gift-finder (keyword-matched, not a real AI) ---------- */
  (function () {
    var trigger = document.querySelector('[data-ai-gift-trigger]');
    var panel = document.querySelector('[data-ai-gift-panel]');
    var backdrop = document.querySelector('[data-ai-gift-backdrop]');
    var closeBtn = document.querySelector('[data-ai-gift-close]');
    var messages = document.querySelector('[data-ai-gift-messages]');
    var form = document.querySelector('[data-ai-gift-form]');
    var input = document.querySelector('[data-ai-gift-input]');
    if (!trigger || !panel || !form || !input || !messages) return;

    /* Load merchant-configured rules (keywords -> products), rendered server-side */
    var rules = Array.prototype.map.call(document.querySelectorAll('[data-gift-rule]'), function (el) {
      var keywords = (el.getAttribute('data-keywords') || '')
        .split(',')
        .map(function (k) { return k.trim().toLowerCase(); })
        .filter(Boolean);
      var products = [];
      try { products = JSON.parse(el.textContent); } catch (e) {}
      return { keywords: keywords, intro: el.getAttribute('data-intro') || 'Here are a few ideas:', products: products };
    });
    var fallbackEl = document.querySelector('[data-gift-fallback]');
    var fallbackProducts = [];
    if (fallbackEl) { try { fallbackProducts = JSON.parse(fallbackEl.textContent); } catch (e) {} }

    function open() {
      panel.hidden = false;
      backdrop.hidden = false;
      trigger.classList.add('is-open');
      requestAnimationFrame(function () { panel.classList.add('is-open'); backdrop.classList.add('is-open'); });
      input.focus();
    }
    function close() {
      panel.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      trigger.classList.remove('is-open');
      setTimeout(function () { panel.hidden = true; backdrop.hidden = true; }, 200);
    }

    trigger.addEventListener('click', function () { panel.hidden ? open() : close(); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });

    function escapeHtmlAI(str) {
      var div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    }

    function addUserMessage(text) {
      var el = document.createElement('div');
      el.className = 'ai-gift-msg ai-gift-msg--user';
      el.textContent = text;
      messages.appendChild(el);
      messages.scrollTop = messages.scrollHeight;
    }

    function addBotMessage(text) {
      var el = document.createElement('div');
      el.className = 'ai-gift-msg ai-gift-msg--bot';
      el.textContent = text;
      messages.appendChild(el);
      messages.scrollTop = messages.scrollHeight;
    }

    function addBotProducts(products) {
      var wrap = document.createElement('div');
      wrap.className = 'ai-gift-products';
      wrap.innerHTML = products.map(function (p) {
        return '' +
          '<a href="' + p.url + '" class="ai-gift-product">' +
            (p.image ? '<img src="' + p.image + '" alt="' + escapeHtmlAI(p.title) + '" loading="lazy">' : '') +
            '<span class="ai-gift-product__title">' + escapeHtmlAI(p.title) + '</span>' +
            '<span class="ai-gift-product__price">' + formatMoney(p.price) + '</span>' +
          '</a>';
      }).join('');
      messages.appendChild(wrap);
      messages.scrollTop = messages.scrollHeight;
    }

    function showTyping() {
      var el = document.createElement('div');
      el.className = 'ai-gift-msg ai-gift-msg--bot ai-gift-typing';
      el.setAttribute('data-ai-gift-typing', '');
      el.innerHTML = '<span></span><span></span><span></span>';
      messages.appendChild(el);
      messages.scrollTop = messages.scrollHeight;
      return el;
    }

    function findMatch(text) {
      var lower = text.toLowerCase();
      for (var i = 0; i < rules.length; i++) {
        for (var j = 0; j < rules[i].keywords.length; j++) {
          if (rules[i].keywords[j] && lower.indexOf(rules[i].keywords[j]) !== -1) return rules[i];
        }
      }
      return null;
    }

    function respondTo(text) {
      var typingEl = showTyping();
      setTimeout(function () {
        typingEl.remove();
        var match = findMatch(text);
        if (match && match.products.length > 0) {
          addBotMessage(match.intro);
          addBotProducts(match.products);
        } else if (fallbackProducts.length > 0) {
          addBotMessage('I could not find an exact match, but you might like these:');
          addBotProducts(fallbackProducts);
        } else {
          addBotMessage('I could not find an exact match — try different words, or browse the full catalog.');
        }
      }, 700 + Math.random() * 500);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var text = input.value.trim();
      if (!text) return;
      addUserMessage(text);
      input.value = '';
      respondTo(text);
    });

    document.querySelectorAll('[data-ai-gift-suggestion]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var text = chip.textContent.trim();
        addUserMessage(text);
        respondTo(text);
        var suggestions = document.querySelector('[data-ai-gift-suggestions]');
        if (suggestions) suggestions.remove();
      });
    });
  })();

  /* ---------- Cookie consent banner ---------- */
  (function () {
    var STORAGE_KEY = 'tg_cookie_consent';
    var banner = document.querySelector('[data-cookie-banner]');
    var prefs = document.querySelector('[data-cookie-prefs]');
    if (!banner || !prefs) return;

    function getConsent() {
      try { return JSON.parse(localStorage.getItem(STORAGE_KEY)); } catch (e) { return null; }
    }
    function setConsent(value) {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(value)); } catch (e) {}
      document.dispatchEvent(new CustomEvent('cookieConsentUpdated', { detail: value }));
    }

    var existing = getConsent();
    if (!existing) { banner.hidden = false; }

    banner.querySelector('[data-cookie-accept]').addEventListener('click', function () {
      setConsent({ necessary: true, analytics: true, marketing: true });
      banner.hidden = true;
    });

    banner.querySelector('[data-cookie-manage]').addEventListener('click', function () {
      prefs.hidden = false;
    });

    prefs.querySelectorAll('[data-cookie-prefs-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { prefs.hidden = true; });
    });

    prefs.querySelector('[data-cookie-save]').addEventListener('click', function () {
      var analytics = prefs.querySelector('[data-cookie-toggle="analytics"]').checked;
      var marketing = prefs.querySelector('[data-cookie-toggle="marketing"]').checked;
      setConsent({ necessary: true, analytics: analytics, marketing: marketing });
      prefs.hidden = true;
      banner.hidden = true;
    });

    /* Example hook: gate analytics/marketing scripts behind consent, e.g.
       document.addEventListener('cookieConsentUpdated', function (e) {
         if (e.detail.analytics) { // load GA / Meta Pixel here }
       });
       If consent was already given in a previous visit, fire once on load too. */
    if (existing) {
      document.dispatchEvent(new CustomEvent('cookieConsentUpdated', { detail: existing }));
    }
  })();

  /* ---------- Back to top button ---------- */
  (function () {
    var btn = document.querySelector('[data-back-to-top]');
    if (!btn) return;

    function toggle() {
      btn.hidden = window.scrollY < 200;
    }

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    toggle();
    window.addEventListener('scroll', toggle, { passive: true });
  })();

  /* ---------- Password show/hide toggles (global — modal + account pages) ---------- */
  document.querySelectorAll('[data-password-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.previousElementSibling;
      if (!input) return;
      var showing = input.type === 'text';
      input.type = showing ? 'password' : 'text';
    });
  });

  /* ---------- Wishlist (localStorage-based, works with or without an account) ---------- */
  var Wishlist = {
    KEY: 'tg_wishlist',
    get: function () {
      try { return JSON.parse(localStorage.getItem(this.KEY)) || []; } catch (e) { return []; }
    },
    save: function (handles) {
      try { localStorage.setItem(this.KEY, JSON.stringify(handles)); } catch (e) {}
    },
    has: function (handle) { return this.get().indexOf(handle) !== -1; },
    toggle: function (handle) {
      var list = this.get();
      var i = list.indexOf(handle);
      if (i === -1) list.push(handle); else list.splice(i, 1);
      this.save(list);
      return i === -1;
    }
  };
  window.ThemeWishlist = Wishlist;

  function refreshWishlistUI() {
    var list = Wishlist.get();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      btn.classList.toggle('is-active', list.indexOf(btn.getAttribute('data-wishlist-toggle')) !== -1);
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function (countEl) {
      countEl.textContent = list.length;
      countEl.hidden = list.length === 0;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    Wishlist.toggle(btn.getAttribute('data-wishlist-toggle'));
    refreshWishlistUI();
    if (btn.closest('[data-wishlist-grid]')) renderWishlistPage();
  });

  refreshWishlistUI();

  /* ---------- Shared: build a product-card's HTML from /products/x.js JSON ---------- */
  function escapeHtmlWL(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function buildProductCardHTML(p, wishlistActive) {
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var hasCompare = p.compare_at_price && p.compare_at_price > p.price;
    var discount = hasCompare ? Math.round((p.compare_at_price - p.price) * 100 / p.compare_at_price) : null;
    var wishClass = 'product-card__tool product-card__wish' + (wishlistActive ? ' is-active' : '');
    var heart = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8z"/></svg>';
    return '' +
      '<div class="product-card product-card--compact">' +
        '<a href="' + p.url + '" class="product-card__media">' +
          (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400" loading="lazy" alt="' + escapeHtmlWL(p.title) + '">' : '') +
          '<span class="product-card__badges">' + (discount ? '<span class="product-card__badge product-card__badge--sale">-' + discount + '%</span>' : '') + '</span>' +
        '</a>' +
        '<div class="product-card__tools"><button type="button" class="' + wishClass + '" aria-label="' + S('add_to_wishlist','Add to wishlist') + '" data-wishlist-toggle="' + p.handle + '">' + heart + '</button></div>' +
        '<div class="product-card__body">' +
          (p.vendor ? '<span class="product-card__vendor">' + escapeHtmlWL(p.vendor) + '</span>' : '') +
          '<a href="' + p.url + '" class="product-card__title">' + escapeHtmlWL(p.title) + '</a>' +
          '<span class="product-card__stock' + (p.available ? '' : ' is-out') + '">' + (p.available ? S('in_stock','In stock') : S('out_of_stock','Out of stock')) + '</span>' +
          '<div class="product-card__price' + (hasCompare ? ' is-sale' : '') + '"><span class="now">' + formatMoney(p.price) + '</span>' +
            (hasCompare ? '<span class="was">' + formatMoney(p.compare_at_price) + '</span>' : '') +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function renderWishlistPage() {
    var grid = document.querySelector('[data-wishlist-grid]');
    var emptyState = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;

    var handles = Wishlist.get();
    if (handles.length === 0) {
      grid.innerHTML = '';
      if (emptyState) emptyState.hidden = false;
      return;
    }
    if (emptyState) emptyState.hidden = true;

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js').then(function (res) {
        return res.ok ? res.json() : null;
      }).catch(function () { return null; });
    })).then(function (products) {
      grid.innerHTML = products.filter(Boolean).map(function (p) {
        return buildProductCardHTML(p, true);
      }).join('');
    });
  }

  renderWishlistPage();

  /* ---------- Product forms (product page + featured product): gallery, zoom, variants, bundles ---------- */
  document.querySelectorAll('[data-product-root]').forEach(function (root) {
    var mainImg = root.querySelector('[data-main-image]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    function setActive(thumb) {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = thumb.getAttribute('data-full'); }
    }
    thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { setActive(thumb); }); });

    var zoom = root.querySelector('[data-zoom]');
    if (zoom && mainImg && window.matchMedia('(hover: hover)').matches && zoom.querySelector('.pdp-gallery__hint')) {
      zoom.addEventListener('mousemove', function (e) {
        var r = zoom.getBoundingClientRect();
        mainImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        zoom.classList.add('is-zoomed');
      });
      zoom.addEventListener('mouseleave', function () { zoom.classList.remove('is-zoomed'); });
    }

    var dataEl = root.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var isMain = root.hasAttribute('data-main-product');

    var optionEls = root.querySelectorAll('[data-option-index]');
    var selected = [];
    optionEls.forEach(function (el) {
      var idx = parseInt(el.getAttribute('data-option-index'), 10);
      var current = el.querySelector('.is-selected');
      selected[idx] = current ? current.getAttribute('data-option-value') : null;
    });
    function findVariant() {
      return product.variants.find(function (v) {
        return selected.every(function (val, i) { return val == null || v.options[i] === val; });
      });
    }

    var stockMap = {};
    try { stockMap = JSON.parse(root.querySelector('[data-product-stock]').textContent); } catch (e) {}
    var stockLine = root.querySelector('[data-stock-line]');
    var lowThreshold = stockLine ? parseInt(stockLine.getAttribute('data-low-threshold'), 10) || 5 : 5;
    var addBtnEl = root.querySelector('[data-add-to-cart-text]');
    var priceInButton = addBtnEl ? addBtnEl.textContent.indexOf('·') > -1 : false;
    var qtyInput = root.querySelector('[data-qty-input]');
    var tiers = root.querySelectorAll('[data-bundle-tier]');

    function tierDiscount() {
      var t = root.querySelector('[data-bundle-tier].is-selected');
      return t ? (parseFloat(t.getAttribute('data-discount')) || 0) : 0;
    }

    function updateTiers(variant) {
      tiers.forEach(function (t) {
        var q = parseInt(t.getAttribute('data-tier-qty'), 10) || 1;
        var d = parseFloat(t.getAttribute('data-discount')) || 0;
        var full = variant.price * q;
        var now = Math.round(full * (1 - d / 100));
        var nowEl = t.querySelector('[data-tier-now]');
        var wasEl = t.querySelector('[data-tier-was]');
        var saveEl = t.querySelector('[data-tier-save]');
        if (nowEl) nowEl.textContent = formatMoney(now);
        if (wasEl) { wasEl.textContent = d > 0 ? formatMoney(full) : ''; wasEl.hidden = !(d > 0); }
        if (saveEl) { saveEl.hidden = !(d > 0); if (d > 0) saveEl.textContent = S('you_save','You save') + ' ' + formatMoney(full - now); }
      });
    }

    function updateUI() {
      var variant = findVariant();
      var priceWrap = root.querySelector('[data-variant-price]');
      var variantIdInput = root.querySelector('[data-variant-id]');
      var addBtn = root.querySelector('[data-add-to-cart]');
      var addBtnText = root.querySelector('[data-add-to-cart-text]');
      var stickyPrice = isMain ? document.querySelector('[data-sticky-price]') : null;
      var badge = root.querySelector('[data-gallery-badge]');
      if (!variant) {
        if (addBtn) addBtn.disabled = true;
        if (addBtnText) addBtnText.textContent = S('unavailable','Unavailable');
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      var hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (priceWrap) {
        priceWrap.innerHTML = '<span class="now' + (hasCompare ? ' is-sale' : '') + '">' + formatMoney(variant.price) + '</span>' +
          (hasCompare ? '<span class="was">' + formatMoney(variant.compare_at_price) + '</span><span class="save">' + S('save','Save') + ' ' + formatMoney(variant.compare_at_price - variant.price) + '</span>' : '');
      }
      if (badge) {
        badge.hidden = !hasCompare;
        if (hasCompare) badge.textContent = '-' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%';
      }
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      var total = Math.round(variant.price * qty * (1 - tierDiscount() / 100));
      if (addBtn) addBtn.disabled = !variant.available;
      if (addBtnText) addBtnText.textContent = variant.available ? (S('add_to_cart','Add to cart') + (priceInButton ? ' · ' + formatMoney(total) : '')) : S('sold_out','Sold out');
      if (variant.featured_image && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = variant.featured_image.src; }
      if (variant.featured_image && thumbs.length) {
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-full').split('?')[0] === String(variant.featured_image.src).split('?')[0]); });
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (stockLine) {
        var st = stockMap[variant.id] || {};
        var cls = 'in', txt = S('in_stock','In stock');
        if (!variant.available) { cls = 'out'; txt = S('out_of_stock','Out of stock'); }
        else if (st.m && !st.p && st.q > 0 && st.q <= lowThreshold) { cls = 'low'; txt = S('low_stock','Low stock — only [count] left').replace('[count]', st.q); }
        stockLine.className = 'stock-line stock-line--' + cls;
        stockLine.querySelector('span').textContent = txt;
      }
      updateTiers(variant);
      optionEls.forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-option-index'), 10);
        var labelStrong = el.querySelector('[data-option-selected]');
        if (labelStrong) labelStrong.textContent = selected[idx];
      });
      if (isMain) document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant, product: product } }));
    }

    root.querySelectorAll('[data-option-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var optionWrap = btn.closest('[data-option-index]');
        var idx = parseInt(optionWrap.getAttribute('data-option-index'), 10);
        selected[idx] = btn.getAttribute('data-option-value');
        optionWrap.querySelectorAll('[data-option-value]').forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('is-selected');
        btn.setAttribute('aria-checked', 'true');
        updateUI();
      });
    });
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (x) { x.classList.remove('is-selected'); x.setAttribute('aria-checked', 'false'); });
        t.classList.add('is-selected');
        t.setAttribute('aria-checked', 'true');
        if (qtyInput) qtyInput.value = t.getAttribute('data-tier-qty');
        updateUI();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', updateUI);
    root.querySelectorAll('[data-qty-minus],[data-qty-plus]').forEach(function (b) { b.addEventListener('click', function () { setTimeout(updateUI, 0); }); });
    if (tiers.length) updateUI();
  });

  /* ---------- Estimated delivery dates ([data-delivery-estimate]) ---------- */
  document.querySelectorAll('[data-delivery-estimate]').forEach(function (el) {
    var min = parseInt(el.getAttribute('data-min'), 10) || 3, max = parseInt(el.getAttribute('data-max'), 10) || 6;
    function addBusinessDays(d, n) {
      var r = new Date(d.getTime());
      while (n > 0) { r.setDate(r.getDate() + 1); if (r.getDay() !== 0 && r.getDay() !== 6) n--; }
      return r;
    }
    var now = new Date();
    var fmt = { weekday: 'short', month: 'short', day: 'numeric' };
    var lang = document.documentElement.lang || undefined;
    var out = el.querySelector('[data-delivery-dates]');
    try {
      var dn = S('days', '').split(','), mn = S('months', '').split(','), df = S('date_format', '');
      var fmtDate = function (d) {
        if (dn.length === 7 && mn.length === 12 && df) return df.replace('[wd]', dn[d.getDay()]).replace('[d]', d.getDate()).replace('[m]', mn[d.getMonth()]);
        return d.toLocaleDateString(lang, fmt);
      };
      if (out) out.textContent = fmtDate(addBusinessDays(now, min)) + ' – ' + fmtDate(addBusinessDays(now, max));
      el.hidden = false;
    } catch (e) {}
  });

  /* ---------- Product page: tabs ---------- */
  (function () {
    var tabsWrap = document.querySelector('[data-tabs]');
    if (!tabsWrap) return;
    var links = tabsWrap.querySelectorAll('[data-tab-link]');
    links.forEach(function (link) {
      link.addEventListener('click', function () {
        var tab = link.getAttribute('data-tab-link');
        links.forEach(function (l) { l.classList.remove('is-active'); });
        link.classList.add('is-active');
        tabsWrap.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-tab-panel') !== tab;
        });
      });
    });
  })();

  /* ---------- Product page: sticky add-to-cart bar ---------- */
  (function () {
    var bar = document.querySelector('[data-sticky-bar]');
    var buyBox = document.querySelector('.buy-box__row');
    if (!bar || !buyBox || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries) {
      bar.hidden = entries[0].isIntersecting;
      document.body.classList.toggle('has-sticky-bar', !bar.hidden);
    }, { threshold: 0 });
    observer.observe(buyBox);

    var stickyBtn = bar.querySelector('[data-sticky-add-to-cart]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var mainForm = document.querySelector('[data-product-form]');
        if (mainForm) mainForm.querySelector('[data-add-to-cart]').click();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  })();

  /* ---------- Product page: share button ---------- */
  (function () {
    var btn = document.querySelector('[data-share-product]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var url = window.location.href;
      if (navigator.share) {
        navigator.share({ title: document.title, url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          btn.setAttribute('title', 'Link copied!');
        });
      }
    });
  })();

  /* ---------- Recently viewed products ---------- */
  (function () {
    var KEY = 'tg_recently_viewed';
    function getViewed() {
      try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
    }
    function saveViewed(list) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }

    var root = document.querySelector('[data-main-product]');
    if (root) {
      var dataEl = root.querySelector('[data-product-json]');
      if (dataEl) {
        var product = JSON.parse(dataEl.textContent);
        var list = getViewed().filter(function (h) { return h !== product.handle; });
        list.unshift(product.handle);
        saveViewed(list.slice(0, 12));
      }
    }

    var section = document.querySelector('[data-recently-viewed]');
    var grid = document.querySelector('[data-recently-viewed-grid]');
    if (!section || !grid) return;

    var currentHandle = root && root.querySelector('[data-product-json]') ? JSON.parse(root.querySelector('[data-product-json]').textContent).handle : null;
    var handles = getViewed().filter(function (h) { return h !== currentHandle; }).slice(0, 10);
    if (handles.length === 0) return;

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js').then(function (res) {
        return res.ok ? res.json() : null;
      }).catch(function () { return null; });
    })).then(function (products) {
      var valid = products.filter(Boolean);
      if (valid.length === 0) return;
      grid.innerHTML = valid.map(function (p) { return buildProductCardHTML(p, Wishlist.has(p.handle)); }).join('');
      section.hidden = false;
    });
  })();

  /* ---------- Product page: "Similar" / "More from brand" tabs ---------- */
  (function () {
    var wrap = document.querySelector('[data-similar]');
    if (!wrap) return;
    var panel = wrap.querySelector('[data-similar-panel="related"]');
    var url = wrap.getAttribute('data-related-url');
    var tabs = wrap.querySelectorAll('[data-similar-tab]');
    function show(name) {
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-similar-tab') === name); });
      wrap.querySelectorAll('[data-similar-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-similar-panel') !== name; });
      wrap.querySelectorAll('[data-similar-link]').forEach(function (l) { l.hidden = l.getAttribute('data-similar-link') !== name; });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.getAttribute('data-similar-tab')); }); });
    if (!panel || !url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var items = doc.querySelector('[data-related-items]');
      if (items && items.children.length) {
        panel.innerHTML = items.innerHTML;
        refreshWishlistUI();
      } else if (tabs.length > 1) {
        tabs[0].remove(); show('vendor');
      } else {
        wrap.hidden = true;
      }
    }).catch(function () {});
  })();

  /* ---------- Product page: bought together ---------- */
  (function () {
    var box = document.querySelector('[data-bought-together]');
    if (!box) return;
    var list = box.querySelector('[data-bt-list]');
    var totalEl = box.querySelector('[data-bt-total]');
    var label = box.querySelector('[data-bt-label]');
    var addBtn = box.querySelector('[data-bt-add]');

    function rows() { return Array.prototype.slice.call(list.querySelectorAll('[data-bt-row]')); }
    function recalc() {
      var total = 0, count = 0;
      rows().forEach(function (r) {
        var on = r.querySelector('[data-bt-check]').checked;
        r.classList.toggle('is-off', !on);
        if (on) { total += parseInt(r.getAttribute('data-price'), 10) || 0; count++; }
      });
      totalEl.textContent = formatMoney(total);
      label.textContent = count > 1 ? S('add_n','Add [count] to cart').replace('[count]', count) : S('add_to_cart','Add to cart');
      addBtn.disabled = count === 0;
    }
    list.addEventListener('change', recalc);

    document.addEventListener('variant:change', function (e) {
      var v = e.detail.variant, current = list.querySelector('.bt-row--current');
      if (!current || !v) return;
      current.setAttribute('data-variant-id', v.id);
      current.setAttribute('data-price', v.price);
      var price = current.querySelector('[data-bt-price]');
      if (price) price.innerHTML = '<b>' + formatMoney(v.price) + '</b>' + (v.compare_at_price > v.price ? '<s>' + formatMoney(v.compare_at_price) + '</s>' : '');
      var title = current.querySelector('[data-bt-title]');
      if (title && e.detail.product && e.detail.product.variants.length > 1) title.textContent = e.detail.product.title + ' — ' + v.title;
      recalc();
    });

    addBtn.addEventListener('click', function () {
      var items = rows().filter(function (r) { return r.querySelector('[data-bt-check]').checked; })
        .map(function (r) { return { id: parseInt(r.getAttribute('data-variant-id'), 10), quantity: 1 }; });
      if (!items.length) return;
      addBtn.disabled = true;
      addToCart({ items: items }).then(function (res) {
        addBtn.disabled = false;
        if (res && res.items && res.items[0]) showCartToast(res.items[0], items.length);
      }).catch(function () { addBtn.disabled = false; });
    });

    var url = box.getAttribute('data-bt-url');
    if (!url) { box.hidden = false; recalc(); return; }
    function load(u, fallback) {
      return fetch(u).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var frag = doc.querySelector('[data-bt-rows]');
        var currentId = list.querySelector('.bt-row--current') ? list.querySelector('.bt-row--current').getAttribute('data-variant-id') : null;
        var added = 0;
        if (frag) Array.prototype.forEach.call(frag.querySelectorAll('[data-bt-row]'), function (r) {
          if (r.getAttribute('data-variant-id') === currentId) return;
          list.appendChild(r); added++;
        });
        if (!added && fallback) return load(fallback, null);
        if (added) { box.hidden = false; recalc(); }
      });
    }
    load(url, url.indexOf('intent=complementary') > -1 ? url.replace('intent=complementary', 'intent=related') : null).catch(function () {});
  })();

  /* ---------- Collection page: AJAX filtering (no full page reload) ---------- */
  function submitFiltersAjax() {
    var form = document.getElementById('FacetFilterForm');
    var layout = document.querySelector('.collection-layout');
    if (!form || !layout) return;

    var sectionWrap = layout.closest('[data-collection-section-id]');
    var sectionId = sectionWrap ? sectionWrap.getAttribute('data-collection-section-id') : null;
    if (!sectionId) { form.submit(); return; }

    var params = new URLSearchParams(new FormData(form));
    var baseUrl = window.location.pathname;
    var queryUrl = baseUrl + '?' + params.toString();
    var fetchUrl = queryUrl + '&section_id=' + sectionId;

    layout.style.opacity = '.5';
    layout.style.pointerEvents = 'none';

    fetch(fetchUrl)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newLayout = doc.querySelector('.collection-layout');
        if (newLayout) {
          layout.replaceWith(newLayout);
          history.pushState({}, '', queryUrl);
          initCollectionFilters();
          refreshWishlistUI();
        } else {
          window.location.href = queryUrl;
        }
      })
      .catch(function () { form.submit(); });
  }

  function initCollectionFilters() {
    var form = document.getElementById('FacetFilterForm');
    if (!form) return;

    /* Intercept every submission (Apply button click or programmatic requestSubmit) */
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitFiltersAjax();
    });

    /* Collapsible filter groups */
    form.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.toggle('is-open');
        var body = btn.nextElementSibling;
        if (body) body.hidden = !btn.classList.contains('is-open');
      });
    });
    document.querySelectorAll('.collection-sidebar > .filter-group [data-filter-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.classList.toggle('is-open');
        var body = btn.nextElementSibling;
        if (body) body.hidden = !btn.classList.contains('is-open');
      });
    });

    /* Auto-submit on checkbox change (price range uses the Apply button / blur instead) */
    form.querySelectorAll('[data-filter-input]').forEach(function (input) {
      input.addEventListener('change', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    });

    /* Sort select */
    var sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }

    /* "Show all" collapsible lists */
    document.querySelectorAll('[data-show-all-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('.filter-group__body');
        var extras = group.querySelectorAll('[data-list-extra]');
        var expanded = extras.length && !extras[0].hidden;
        extras.forEach(function (el) { el.hidden = expanded; });
        var label = btn.querySelector('[data-show-all-label]');
        if (label) label.textContent = expanded ? S('show_all','Show all') : S('show_less','Show less');
        btn.classList.toggle('is-open', !expanded);
      });
    });

    /* Dual-handle price range slider */
    document.querySelectorAll('[data-price-slider]').forEach(function (wrap) {
      var rangeMax = parseFloat(wrap.getAttribute('data-range-max')) || 100;
      var minRange = wrap.querySelector('[data-price-range="min"]');
      var maxRange = wrap.querySelector('[data-price-range="max"]');
      var fill = wrap.querySelector('[data-price-fill]');
      var group = wrap.closest('.filter-group__body');
      var minInput = group ? group.querySelector('[data-price-input="min"]') : null;
      var maxInput = group ? group.querySelector('[data-price-input="max"]') : null;
      if (!minRange || !maxRange) return;

      function paintFill() {
        var minVal = parseFloat(minRange.value) || 0;
        var maxVal = parseFloat(maxRange.value) || rangeMax;
        if (fill) {
          fill.style.left = (minVal / rangeMax * 100) + '%';
          fill.style.right = (100 - (maxVal / rangeMax * 100)) + '%';
        }
      }

      function clampRanges(source) {
        var minVal = parseFloat(minRange.value);
        var maxVal = parseFloat(maxRange.value);
        if (minVal > maxVal) {
          if (source === 'min') minRange.value = maxVal; else maxRange.value = minVal;
        }
      }

      minRange.addEventListener('input', function () {
        clampRanges('min');
        if (minInput) minInput.value = minRange.value;
        paintFill();
      });
      maxRange.addEventListener('input', function () {
        clampRanges('max');
        if (maxInput) maxInput.value = maxRange.value;
        paintFill();
      });
      minRange.addEventListener('change', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
      maxRange.addEventListener('change', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });

      if (minInput) {
        minInput.addEventListener('input', function () {
          var val = parseFloat(minInput.value);
          if (!isNaN(val)) { minRange.value = val; paintFill(); }
        });
        minInput.addEventListener('change', function () {
          if (minInput.value === '') minRange.value = 0;
          clampRanges('min');
          minInput.value = minRange.value;
          paintFill();
          form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }
      if (maxInput) {
        maxInput.addEventListener('input', function () {
          var val = parseFloat(maxInput.value);
          if (!isNaN(val)) { maxRange.value = val; paintFill(); }
        });
        maxInput.addEventListener('change', function () {
          if (maxInput.value === '') maxRange.value = rangeMax;
          clampRanges('max');
          maxInput.value = maxRange.value;
          paintFill();
          form.requestSubmit ? form.requestSubmit() : form.submit();
        });
      }

      paintFill();
    });

    /* View density toggle */
    var toggle = document.querySelector('[data-view-toggle]');
    var grid = document.querySelector('[data-collection-grid]');
    if (toggle && grid) {
      function setView(view) {
        grid.setAttribute('data-view', view);
        toggle.querySelectorAll('button').forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-view') === view);
        });
        try { localStorage.setItem('tg_collection_view', view); } catch (e) {}
      }
      toggle.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () { setView(btn.getAttribute('data-view')); });
      });
      var saved = null;
      try { saved = localStorage.getItem('tg_collection_view'); } catch (e) {}
      if (saved) setView(saved);
    }

    /* Items-per-page select */
    document.querySelectorAll('[data-per-page-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        window.location.href = select.value;
      });
    });

    /* "Show more" progressively loads the next page */
    document.querySelectorAll('[data-show-more]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var url = btn.getAttribute('href');
        var gridSelector = btn.getAttribute('data-grid-selector');
        var targetGrid = document.querySelector(gridSelector);
        if (!targetGrid) return;

        btn.textContent = S('loading','Loading…');
        fetch(url)
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector(gridSelector);
            var newBtn = doc.querySelector('[data-show-more]');
            if (newGrid) targetGrid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
            if (newBtn) {
              btn.setAttribute('href', newBtn.getAttribute('href'));
              btn.textContent = S('show_more','Show more');
            } else {
              btn.closest('.collection-showmore').remove();
            }
            refreshWishlistUI();
          })
          .catch(function () { btn.textContent = S('show_more','Show more'); });
      });
    });
    /* Mobile filter bottom-sheet */
    var filterTrigger = document.querySelector('[data-filter-trigger]');
    var sidebar = document.querySelector('.collection-sidebar');
    var backdrop = document.querySelector('[data-filter-backdrop]');

    function openFilterSheet() {
      if (sidebar) sidebar.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.classList.add('filter-sheet-open');
    }
    function closeFilterSheet() {
      if (sidebar) sidebar.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.classList.remove('filter-sheet-open');
    }
    if (filterTrigger) filterTrigger.addEventListener('click', openFilterSheet);
    document.querySelectorAll('[data-filter-close]').forEach(function (btn) {
      btn.addEventListener('click', closeFilterSheet);
    });
    if (backdrop) backdrop.addEventListener('click', closeFilterSheet);

    /* Keep the sheet open across an AJAX filter refresh instead of snapping shut */
    if (document.body.classList.contains('filter-sheet-open')) openFilterSheet();
  }

  /* Closing via Escape is bound once, not re-bound on every AJAX refresh */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!document.body.classList.contains('filter-sheet-open')) return;
    var sidebar = document.querySelector('.collection-sidebar');
    var backdrop = document.querySelector('[data-filter-backdrop]');
    if (sidebar) sidebar.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
    document.body.classList.remove('filter-sheet-open');
  });

  initCollectionFilters();

});

/* License check runs on its own, so an error elsewhere can never skip it. */
document.addEventListener('DOMContentLoaded', function () {
  /* ---------- License check (optional — see README) ---------- */
  (function () {
    function licEsc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    var b = document.body;
    var url = b.getAttribute('data-license-url');
    if (!url) return;
    var mode = b.getAttribute('data-license-mode') || 'banner';
    var key = b.getAttribute('data-license-key') || '';
    var shop = b.getAttribute('data-shop-domain') || location.hostname;
    var cacheKey = 'license_ok_' + key;

    function fail(reason) {
      if (mode === 'lock' && b.getAttribute('data-design-mode') !== 'true') {
        var lock = document.createElement('div');
        lock.className = 'license-lock';
        lock.innerHTML = '<div><h1>License required</h1><p>' + licEsc(reason) + '</p></div>';
        b.appendChild(lock);
        return;
      }
      var bar = document.createElement('div');
      bar.className = 'license-banner';
      bar.textContent = reason;
      b.insertBefore(bar, b.firstChild);
      if (mode === 'popup') {
        var pop = document.createElement('div');
        pop.className = 'license-popup';
        pop.setAttribute('role', 'dialog');
        pop.setAttribute('aria-modal', 'true');
        pop.innerHTML =
          '<div class="license-popup__box">' +
            '<button type="button" class="license-popup__close" aria-label="Close">&times;</button>' +
            '<div class="license-popup__icon">!</div>' +
            '<h2>Unlicensed theme</h2>' +
            '<p>' + licEsc(reason) + '</p>' +
            '<p class="license-popup__hint"><strong>Store owner:</strong> Online Store &rarr; Themes &rarr; Customize &rarr; Theme settings &rarr; License. Your purchase code is in your order confirmation email.</p>' +
          '</div>';
        b.appendChild(pop);
        pop.querySelector('.license-popup__close').addEventListener('click', function () { pop.remove(); });
      }
    }

    if (!key) { fail('This theme is not licensed. Enter your purchase code in Theme settings → License.'); return; }
    try {
      var cached = parseInt(sessionStorage.getItem(cacheKey) || '0', 10);
      if (cached && Date.now() - cached < 6 * 3600 * 1000) return;
    } catch (e) {}

    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'key=' + encodeURIComponent(key) + '&shop=' + encodeURIComponent(shop))
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.valid === true) {
          try { sessionStorage.setItem(cacheKey, String(Date.now())); } catch (e) {}
        } else {
          fail((data && data.message) || 'This license key is not valid for this store.');
        }
      })
      .catch(function () { /* network problem: fail open so customers are never locked out by an outage */ });
  })();
});


/* =========================================================
   PRINTSHOP LAYER — language switch, quick add sizes, card swatches,
   personalisation fields, size guide modal, variant URL + availability
   ========================================================= */
document.addEventListener('DOMContentLoaded', function () {
  var b = document.body;

  /* ---------- GEO / ENG switch (Google Translate mode) ---------- */
  var primary = b.getAttribute('data-lang-primary') || 'ka', second = b.getAttribute('data-lang-second') || 'en';
  function gtCookie() { var m = document.cookie.match(/(?:^|; )googtrans=([^;]*)/); return m ? decodeURIComponent(m[1]) : ''; }
  function isSecond() { return gtCookie() === '/' + primary + '/' + second; }
  function setGt(val) {
    var host = location.hostname, parts = host.split('.'), root = parts.slice(-2).join('.');
    var expire = val ? '' : ';expires=Thu, 01 Jan 1970 00:00:00 GMT';
    [';path=/', ';path=/;domain=' + host, ';path=/;domain=.' + host, ';path=/;domain=.' + root].forEach(function (suffix) {
      document.cookie = 'googtrans=' + (val || '') + suffix + expire;
    });
  }
  document.querySelectorAll('[data-lang-google]').forEach(function (btn) {
    var label = btn.querySelector('[data-lang-label]');
    if (isSecond()) { btn.classList.add('is-second'); if (label) label.textContent = btn.getAttribute('data-label-primary'); }
    btn.addEventListener('click', function () {
      if (isSecond()) setGt(null); else setGt('/' + primary + '/' + second);
      location.reload();
    });
  });

  /* ---------- Quick add: size buttons on product cards ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-variant]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-quick-variant'), 10);
    btn.classList.add('is-loading');
    if (!window.ThemeCart || b.getAttribute('data-ajax-cart') !== 'true') {
      var f = document.createElement('form'); f.method = 'post'; f.action = (b.getAttribute('data-cart-add-url') || '/cart/add');
      f.innerHTML = '<input type="hidden" name="id" value="' + id + '"><input type="hidden" name="quantity" value="1">';
      document.body.appendChild(f); f.submit(); return;
    }
    window.ThemeCart.add({ items: [{ id: id, quantity: 1 }] }).then(function (data) {
      btn.classList.remove('is-loading'); btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 1400);
      var item = data.items ? data.items[0] : data;
      window.ThemeCart.toast(item, 1);
    }).catch(function (err) { btn.classList.remove('is-loading'); window.ThemeCart.toast(null, 0, err.message); });
  });

  /* ---------- Card colour dots swap the image on hover ---------- */
  document.querySelectorAll('.card-swatch[data-card-image]').forEach(function (sw) {
    var card = sw.closest('.product-card'), img = card && card.querySelector('.product-card__img');
    if (!img) return;
    var orig = img.getAttribute('src'), origSet = img.getAttribute('srcset');
    sw.addEventListener('mouseenter', function () { img.removeAttribute('srcset'); img.src = sw.getAttribute('data-card-image'); card.classList.add('is-swatching'); });
    sw.closest('.card-swatches').addEventListener('mouseleave', function () { img.src = orig; if (origSet) img.setAttribute('srcset', origSet); card.classList.remove('is-swatching'); });
  });

  /* ---------- Modals ([data-modal-open] → [data-modal]) ---------- */
  function openModal(name) {
    var m = document.querySelector('[data-modal="' + name + '"]');
    if (!m) return;
    m.hidden = false; document.documentElement.classList.add('has-modal');
    requestAnimationFrame(function () { m.classList.add('is-open'); });
    var c = m.querySelector('[data-modal-close].modal__close'); if (c) c.focus();
  }
  function closeModal(m) {
    m.classList.remove('is-open'); document.documentElement.classList.remove('has-modal');
    setTimeout(function () { m.hidden = true; }, 200);
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-modal-open]');
    if (o) { e.preventDefault(); openModal(o.getAttribute('data-modal-open')); return; }
    var c = e.target.closest('[data-modal-close]');
    if (c) closeModal(c.closest('[data-modal]'));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-modal].is-open').forEach(closeModal);
  });

  /* ---------- Product page: personalisation, availability, URL ---------- */
  var root = document.querySelector('[data-main-product]');
  if (root) {
    var pers = root.querySelector('[data-personalize]');
    var yes = pers ? pers.getAttribute('data-yes').toLowerCase().split(',').map(function (x) { return x.trim(); }) : [];
    var productData = null;
    try { productData = JSON.parse(root.querySelector('[data-product-json]').textContent); } catch (err) {}
    function selectedValues() {
      var vals = [];
      root.querySelectorAll('[data-option-index]').forEach(function (el) {
        var cur = el.querySelector('.is-selected');
        vals[parseInt(el.getAttribute('data-option-index'), 10)] = cur ? cur.getAttribute('data-option-value') : null;
      });
      return vals;
    }
    function markAvailability() {
      if (!productData) return;
      var vals = selectedValues();
      root.querySelectorAll('[data-option-index]').forEach(function (el) {
        var idx = parseInt(el.getAttribute('data-option-index'), 10);
        el.querySelectorAll('[data-option-value]').forEach(function (btn) {
          var val = btn.getAttribute('data-option-value');
          var ok = productData.variants.some(function (v) {
            if (!v.available || v.options[idx] !== val) return false;
            return vals.every(function (sv, i) { return i === idx || sv == null || v.options[i] === sv; });
          });
          btn.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function syncPers(variant) {
      if (!pers) return;
      var idx = parseInt(pers.getAttribute('data-pers-index'), 10);
      var val = variant ? String(variant.options[idx] || '').toLowerCase() : '';
      var on = yes.indexOf(val) > -1;
      pers.hidden = !on;
      pers.querySelectorAll('[data-pers-input]').forEach(function (i) { i.required = on; if (!on) i.value = ''; i.disabled = !on; });
    }
    document.addEventListener('variant:change', function (e) {
      var v = e.detail.variant;
      syncPers(v); markAvailability();
      if (v && window.history && history.replaceState) {
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString());
      }
    });
    root.querySelectorAll('[data-option-value]').forEach(function (btn) { btn.addEventListener('click', function () { setTimeout(function () { markAvailability(); }, 0); }); });
    markAvailability();
    if (pers && productData) {
      var vals0 = selectedValues();
      syncPers(productData.variants.find(function (v) { return vals0.every(function (sv, i) { return sv == null || v.options[i] === sv; }); }));
    }
  }
});
/* ---------- Drag-to-scroll with the mouse on every slider ---------- */
(function () {
  var SEL = '.product-rail, .review-rail, .badge-rail, .banner-rail, .category-rail, .cat-tiles, .brand-rail, .ccards__grid, .tchips__featured, .tchips__list, .pdp-gallery__thumbs, [data-drag-scroll]';
  var drag = null, blockClickUntil = 0;

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    if (e.target.closest('input, select, textarea, button, label, [contenteditable]')) return;
    var el = e.target.closest(SEL);
    if (!el || el.scrollWidth <= el.clientWidth + 2) return;
    drag = { el: el, id: e.pointerId, x: e.clientX, left: el.scrollLeft, moved: false, lx: e.clientX, lt: e.timeStamp, v: 0 };
  });

  document.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    var dx = e.clientX - drag.x;
    if (!drag.moved) {
      if (Math.abs(dx) < 6) return;
      drag.moved = true;
      drag.el.classList.add('is-dragging');
      try { drag.el.setPointerCapture(e.pointerId); } catch (err) {}
    }
    e.preventDefault();
    drag.el.scrollLeft = drag.left - dx;
    var dt = e.timeStamp - drag.lt;
    if (dt > 0) { drag.v = (e.clientX - drag.lx) / dt; drag.lx = e.clientX; drag.lt = e.timeStamp; }
  });

  function end(e) {
    if (!drag || (e && e.pointerId !== drag.id)) return;
    var d = drag; drag = null;
    if (!d.moved) return;
    blockClickUntil = Date.now() + 350;
    try { d.el.releasePointerCapture(d.id); } catch (err) {}
    var fling = Math.max(-1.6, Math.min(1.6, d.v)) * -180;
    d.el.classList.remove('is-dragging');
    if (Math.abs(fling) > 20) d.el.scrollBy({ left: fling, behavior: 'smooth' });
  }
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);

  document.addEventListener('click', function (e) {
    if (Date.now() < blockClickUntil && e.target.closest(SEL)) { e.preventDefault(); e.stopPropagation(); blockClickUntil = 0; }
  }, true);
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest(SEL)) e.preventDefault();
  });
})();